import type { FetchProcessDetailsResponseData } from 'gcs-common/clients/api/entities/processes/processes-api-helpers';
import styles from './styles.module.scss';

interface ProductSelectedDisplayProps {
  product: FetchProcessDetailsResponseData['items'][number];
  isMessage?: boolean;
}

const ProductSelectedDisplay = (props: ProductSelectedDisplayProps) => {
  const { product, isMessage = false } = props;
  return (
    <div className={isMessage ? styles.productMessage : styles.productWrapperSansBorder}>
      <div className={styles.productArticleNumber}>{product.ArticleNumber}</div>
      <div className={styles.productDescription}>
        <div>{product.ArticleDescription1}</div>
        <div>{product.ArticleDescription2}</div>
      </div>
    </div>
  );
};

export default ProductSelectedDisplay;
